const isPreviewKey = key => typeof key === 'string' && /^(gab-html-state-v1:|gab-html-history-v1:)/.test(key);

// Shared HTML hooks keep their ordinary storage contract. Native validates the
// account encoded in each preview key; auth and other preferences stay on their
// existing backend, without copying credentials into the preview cache.
export function createWindowsHtmlPreviewStorage(native, ordinary) {
  const call = async (method, key, value) => {
    if (typeof native?.[method] !== 'function') throw new Error('Rebuild Windows to persist HTML preview state.');
    const raw = await native[method](key, ...(method === 'setItem' ? [value] : []));
    const result = JSON.parse(raw);
    if (!result || !Object.prototype.hasOwnProperty.call(result, 'value') ||
      (method === 'getItem' ? result.value !== null && typeof result.value !== 'string' : result.value !== null))
      throw new Error('Could not confirm HTML preview storage.');
    return result.value;
  };
  return {
    getItem: key => isPreviewKey(key) ? call('getItem', key) : ordinary.getItem(key),
    setItem: (key, value) => isPreviewKey(key) ? call('setItem', key, value).then(() => undefined) : ordinary.setItem(key, value),
    removeItem: key => isPreviewKey(key) ? call('removeItem', key).then(() => undefined) : ordinary.removeItem(key),
  };
}
